import { env } from './env'

export const addMissingUrlProtocol = (url: string) => {
	const protocolRegex = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//
	if (protocolRegex.test(url)) {
		return url
	}
	return `https://${url}`
}

export const removeUrlProtocol = (url: string) => {
	if (!url) {
		return ''
	}
	return url.replace(/^\w+:\/\//, '')
}

export const buildUrl = (uri: string) => `${env.HOST}/${uri}`

export const buildMobiUrl = (uri: string) => `${env.MOBI_URL}/${uri}`
